import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  EbasketApiMethodTypes,
  EbasketInventoryParasparSelectApi,
  EbasketInventorySelectApi,
  EbasketSalesExportSelectApi,
  Providers
} from '@shared/interfaces';
import { SelectApiPopupComponent } from '@shared/select-api-popup/select-api-popup.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'salesforce-provider-api-details-settings',
  templateUrl: './salesforce-provider-details-settings.component.html',
  styleUrls: ['./salesforce-provider-details-settings.component.scss']
})
export class SalesforceApiDetailsSettingsComponent implements OnInit {
  @Input() action: string;
  @Input() parentForm: UntypedFormGroup;
  @Input() saleExportSalesforceApiDetails: any;
  @Input() authControlKey: string;
  @Input() provider: string;
  // @Output() updateApiData: EventEmitter<any> = new EventEmitter();
  apiDetails: UntypedFormGroup;
  isEBasketMixSaleSalesforceAddDisabled = false;
  defaultSignatureMethod = 'HMAC-SHA256';
  ebasket_mixsale_salesforce_select_api = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.ebasket_mixsale_salesforce_select_api = [
      {
        id: 1,
        name: EbasketSalesExportSelectApi.ProcessOrders,
        value: EbasketSalesExportSelectApi.ProcessOrders,
        isDisabled: false
      }
    ];

    this.initForm();
    this.bindEbasketmixSaleSaleforceApiDetailsFormGroup();
  }
  initForm() {
    this.parentForm.addControl(
      this.authControlKey,
      this.formBuilder.group({
        ebasketMixSaleSalesforceClientId: [
          {
            value:
              this.saleExportSalesforceApiDetails && this.saleExportSalesforceApiDetails.apiDetails
                ? Providers.SECRET
                : '',
            disabled: this.action === 'view' ? true : false
          },
          [Validators.required]
        ],
        salesforceVersion: [
          {
            value:
              this.saleExportSalesforceApiDetails && this.saleExportSalesforceApiDetails.version
                ? this.saleExportSalesforceApiDetails.version
                : '1',
            disabled: this.action === 'view' ? true : false
          },
          [Validators.required]
        ],
        ebasketMixSaleSalesforceApiDetails: this.formBuilder.array([])
      })
    );
  }

  bindEbasketmixSaleSaleforceApiDetailsFormGroup() {
    const control = this.parentForm
      .get(this.authControlKey)
      .get('ebasketMixSaleSalesforceApiDetails') as UntypedFormArray;
    if (this.saleExportSalesforceApiDetails && this.saleExportSalesforceApiDetails.apiDetails) {
      this.saleExportSalesforceApiDetails.apiDetails.map((apis: any) => {
        let apiDetails = {};
        apiDetails = {
          url: [
            {
              value: apis.url,
              disabled: this.action === 'view' ? true : false
            },
            Validators.required
          ],
          selectedApi: [apis.selectedApi]
        };

        control.push(this.formBuilder.group(apiDetails));
        this.ebasket_mixsale_salesforce_select_api.map((key) => {
          if (key.value === apis.selectedApi) {
            key.isDisabled = true;
          }
        });
      });
      if (this.ebasket_mixsale_salesforce_select_api.length === control.length) {
        this.isEBasketMixSaleSalesforceAddDisabled = true;
      }
    }
  }
  openEbasketMixSaleSalesforceSelectApiPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = this.ebasket_mixsale_salesforce_select_api.filter((api) => !api.isDisabled);
    const dialogRef = this.dialog.open(SelectApiPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result !== '') {
        this.ebasket_mixsale_salesforce_select_api.map((element: any) => {
          if (element.value === result) {
            element.isDisabled = true;
            // this.tm_gift_card_api_details.push(element);
            const ebasketMixSaleSalesforceApiDetails = this.parentForm
              .get(this.authControlKey)
              .get('ebasketMixSaleSalesforceApiDetails') as UntypedFormArray;
            ebasketMixSaleSalesforceApiDetails.push(
              this.createSalesforceApiDetailsFormGroup(result)
            );
            if (
              this.ebasket_mixsale_salesforce_select_api.length ===
              ebasketMixSaleSalesforceApiDetails.length
            ) {
              this.isEBasketMixSaleSalesforceAddDisabled = true;
            }
          }
        });
      }
    });
  }
  deleteEbasketSalesforceApiDetailContainer(index: number) {
    const ebasketMixSaleSalesforceApiDetails = this.parentForm
      .get(this.authControlKey)
      .get('ebasketMixSaleSalesforceApiDetails') as UntypedFormArray;
    this.ebasket_mixsale_salesforce_select_api.map((element: any) => {
      if (element.value === ebasketMixSaleSalesforceApiDetails.value[index].selectedApi) {
        element.isDisabled = false;
      }
    });
    if (ebasketMixSaleSalesforceApiDetails.length > 0) {
      ebasketMixSaleSalesforceApiDetails.removeAt(index);
    } else {
      ebasketMixSaleSalesforceApiDetails.reset();
    }
    if (
      this.ebasket_mixsale_salesforce_select_api.length !==
      ebasketMixSaleSalesforceApiDetails.length
    ) {
      this.isEBasketMixSaleSalesforceAddDisabled = false;
    }
  }
  private createSalesforceApiDetailsFormGroup(selectedApi: string): UntypedFormGroup {
    return new UntypedFormGroup({
      url: new UntypedFormControl('', Validators.required),
      selectedApi: new UntypedFormControl(selectedApi)
    });
  }
  isRequired(control: string) {
    let isRequired = false;
    const formControlObject = this.parentForm.get(this.authControlKey).get(control);
    if (formControlObject !== null) {
      if (formControlObject.validator !== null) {
        if (formControlObject.validator({} as AbstractControl) !== null) {
          isRequired = formControlObject.validator({} as AbstractControl).required ? true : false;
        }
      }
    }
    return isRequired ? true : false;
  }
}
